import api from './api';

export const SignInProfile = (data) => api.post('profile/signin', data).then(res => res.data);
export const SignUpProfile = (data) => api.post('profile/signup', data).then(res => res.data);
export const ForgotPassword = (data) => api.post('profile/forgot', data).then(res => res.data);
export const RestorePassword = (data) => api.post('profile/restore', data).then(res => res.data);
export const VerificationCode = (data) => api.post('validation/code', data).then(res => res.data);

export const GetProfile = () => api.get('profile/self').then(res => res.data);
export const UpdateProfile = (data) => api.put('profile/self', data).then(res => res.data);
